<template>
    <v-app id="login" class="grey lighten-1">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>

                        <v-form v-on:submit.prevent="login">

                            <v-card class="elevation-1 ">
                                <v-card-title>
                                    <!-- <img :src="logo" class="mr-4" style="width:10%;  display:inline-block;"> -->
                                    <h1 class="font-weight-light display-1 black--text display:inline-block;"><span class="red--text text--darken-4">SGCC</span> Payslip</h1>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text>
                                    <div class="layout column ">
                                        <div :hidden="hideInvalidCreds" class="red--text">
                                            <v-alert :value="true" color="error" outline>
                                                {{errMsg}}
                                            </v-alert>
                                        </div>
                                    </div>
                                    <v-text-field :disabled="loading" prepend-icon="fa-user-tie" name="login" label="Employee ID" type="text" v-model="model.login"></v-text-field>
                                    <v-text-field :disabled="loading" prepend-icon="fa-unlock-alt" name="password" label="Password" id="password" type="password" v-model="model.password"></v-text-field>
                                </v-card-text>
                                <v-divider></v-divider>
                                <v-card-actions class="pa-3">
                                    <router-link :to="`/activate/account`" class="mr-1">Activate Account</router-link> 
                                    <router-link :to="`/forgot/payslip/password`" class="ml-1">Forgot Payslip Password</router-link>
                                    <router-link :to="`/forgot/personal/password`" class="ml-1">Forgot Password</router-link>
                                    <v-spacer></v-spacer>
                                    <v-btn type="submit" class="blue darken-4 white--text" :loading="loading">Login</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import VueCookies from 'vue-cookies';
    import axios from 'axios';

    export default {
        created : function(){
            console.log(this.model.login);
        },
        data : function(){
            return {
                message : '',
                hideInvalidCreds : true,
                loading: false,
                model: {
                    login: '',
                    password: ''
                },
                errMsg : ''
            }
        },
        methods : {
            login : function(){
                let
                _this = this,
                axiosInstance = axios.create({
                    method: 'post',
                    headers: { }
                }),
                formData = new FormData();

                _this.loading = true;

                formData.append('login', _this.model.login);
                formData.append('password', _this.model.password);

                _this.hideInvalidCreds = true;

                axiosInstance
                .post( _this.apiUrl + '/login', formData )
                .then(function(res){
                    if(res.data.status){
                        VueCookies.set(_this.cookieKey, res.data)

                        _this.userRoles = res.data.data.roles;
                        _this.userData = res.data.data.user;

                        setTimeout(() => {
                            _this.$router.push('/payslip/list');
                        }, 300);
                    }else{
                        _this.errMsg = res.data.message;
                        _this.loading = false;
                        _this.hideInvalidCreds = false;
                    }
                })
                .catch(function(err){
                    console.log('err', err);
                    _this.loading = false;
                    _this.hideInvalidCreds = false;
                    _this.errMsg = 'Invalid Credentials';
                });
            }
        }
    };
</script>

// Add style for login page only using `scoped` attribute
<style scoped>
#login{
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}
</style>
